// @flow
import ReportSectionCSS from './ReportSectionCSS';

export default ReportSectionCSS;
